// To avoid re-renders use this static empty array
export const EMPTY_ARRAY = Object.freeze([]) as never[];
export const EMPTY_OBJECT = Object.freeze({});
